import { render, staticRenderFns } from "./checkInRecord.vue?vue&type=template&id=0b6bc02a&scoped=true&"
import script from "./checkInRecord.vue?vue&type=script&lang=js&"
export * from "./checkInRecord.vue?vue&type=script&lang=js&"
import style0 from "./checkInRecord.vue?vue&type=style&index=0&id=0b6bc02a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6bc02a",
  null
  
)

export default component.exports